/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Home/components/HowToSubmitSection.tsx.
 */

import React from "react";
import "./HowToSubmitSection.css";

const HowToSubmitSection: React.FC = () => {
  return (
    <section className="home-section">
      <h2 className="section-heading">How to submit data</h2>
      <div className="steps-grid">
        {/* Step 1 */}
        <div className="step-card">
          <div className="step-card-icon">
            <img src="/images/data_entry_step2.PNG" alt="Choose data entry method" loading="lazy" />
          </div>
          <h3 className="step-card-title">Step 1: Choose data entry method</h3>
          <ul className="step-card-list">
            <li>Option 1: Enter data manually</li>
            <li>Option 2: Import data using excel template</li>
          </ul>
        </div>

        {/* Step 2 */}
        <div className="step-card">
          <div className="step-card-icon">
            <img src="/images/data_entry_step1.PNG" alt="Start data entry" loading="lazy" />
          </div>
          <h3 className="step-card-title">Step 2: Start data entry</h3>
          <p className="step-card-description">
            Begin by selecting the material and material sub-type for which data is being submitted.
          </p>
        </div>

        {/* Step 3 */}
        <div className="step-card">
          <div className="step-card-icon">
            <img src="/images/data_entry_step3.PNG" alt="Review data" loading="lazy" />
          </div>
          <h3 className="step-card-title">Step 3: Review data</h3>
          <p className="step-card-description">
            Before submission, contributors can:
          </p>
          <ul className="step-card-list">
            <li>Review all entered values</li>
            <li>Check completeness of required fields</li>
          </ul>
          <p className="step-card-note">
            The platform highlights missing or inconsistent entries to support quality control.
          </p>
        </div>

        {/* Step 4 */}
        <div className="step-card">
          <div className="step-card-icon">
            <img src="/images/data_entry_step4.PNG" alt="Submit data" loading="lazy" />
          </div>
          <h3 className="step-card-title">Step 4: Submit data</h3>
          <p className="step-card-description">
            Once reviewed, submit the dataset for evaluation.
          </p>
          <h4 className="step-card-subheading">Submitted data:</h4>
          <ul className="step-card-list">
            <li>Enters the data review and screening process</li>
            <li>Is assessed against ICOMEC's data reliability criteria</li>
            <li>May be accepted, or returned for revision</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

/** React component — How To Submit Section. */
export default HowToSubmitSection;

